import UserSetPasswordRequestModel from '../../generated/types/model/resource/UserSetPasswordRequestModel';

export default class UserSetPasswordRequestViewModel extends UserSetPasswordRequestModel {
  repeatNewPassword?: string = undefined;
}
